import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { RIGHT } from '@/api';
import { useRouterStore } from '@/store';
import { ROUTE } from '@/router/routes-enum';
import { buildMenuTreeFromRoutes } from '@/lib/vue-router-menu';
import { useGameCategoryPresetsBase } from '@/hooks/useGameCategoryPresets';
import { useUserRights } from '@/hooks/useUserRights';
import MenuTree from './MenuTree.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Sidebar',
    props: {
        isCollapsed: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const currentRoute = useRoute();
        const currentActiveMenuItem = computed(() => {
            const { name } = currentRoute;
            return (name === null || name === void 0 ? void 0 : name.toString()) || '';
        });
        const { hasRights } = useUserRights();
        const { data: categoryPresets } = useGameCategoryPresetsBase({
            enabled: hasRights(RIGHT.MANAGE_CATEGORY_LOCALE_SETTINGS),
            retry: false,
        });
        const getIconByPresetUrl = (presetUrl) => {
            if (presetUrl.includes('live'))
                return 'video-play';
            if (presetUrl.includes('quick'))
                return 'switch-filled';
            return 'guide';
        };
        const routerStore = useRouterStore();
        const routesForMenu = computed(() => buildMenuTreeFromRoutes(routerStore.routes, [
            (route) => {
                var _a, _b, _c;
                if (route.name !== ROUTE.GAME_CATEGORIES_WRAP
                    || !((_a = categoryPresets.value) === null || _a === void 0 ? void 0 : _a.length))
                    return route;
                const [presetRoute, ...rest] = (_b = route.children) !== null && _b !== void 0 ? _b : [];
                return Object.assign(Object.assign({}, route), { children: [...((_c = categoryPresets.value) !== null && _c !== void 0 ? _c : []).map((preset) => (Object.assign(Object.assign({}, presetRoute), { path: String(preset.id), meta: Object.assign(Object.assign({}, presetRoute === null || presetRoute === void 0 ? void 0 : presetRoute.meta), { title: preset.nameEn, icon: getIconByPresetUrl(preset.url), showInMenu: true, params: { presetId: preset.id } }) }))), ...rest] });
            },
        ]));
        return (_ctx, _cache) => {
            const _component_ElMenu = _resolveComponent("ElMenu");
            const _component_ElScrollbar = _resolveComponent("ElScrollbar");
            return (_openBlock(), _createBlock(_component_ElScrollbar, null, {
                default: _withCtx(() => [
                    _createVNode(_component_ElMenu, {
                        class: "menu",
                        "default-active": currentActiveMenuItem.value,
                        collapse: props.isCollapsed,
                        "unique-opened": false,
                        mode: "vertical",
                        "background-color": "transparent",
                        "text-color": "#BFCBD9",
                        "active-text-color": "#409EFF"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(MenuTree, {
                                tree: routesForMenu.value,
                                "is-collapsed": props.isCollapsed
                            }, null, 8, ["tree", "is-collapsed"])
                        ]),
                        _: 1
                    }, 8, ["default-active", "collapse"])
                ]),
                _: 1
            }));
        };
    }
});
